import { createContext, useContext } from 'react';

import { BaseModule, ModulesApi } from '../injectable';
import { Zed } from '../Zed';

export const ZedContext = createContext<Zed<{}> | undefined>(undefined);

export function useZed<Modules extends BaseModule[]>() {
  return useContext(ZedContext) as Zed<ModulesApi<Modules>> | undefined;
}
